import { Order } from '@/entities/orders/models/Order'
import { AlertType } from '@/shared/components/GridTable/GridCells/AlertGridCell'
import { GridTableDragType } from '@/shared/components/GridTable/models/GridTableDragType'
import { faEarth } from '@fortawesome/pro-solid-svg-icons'
import { EntityId } from '@reduxjs/toolkit'

import { OrderStatusTypeString } from '../model/OrderStatusType'
import { PlanningUnassignedGridRow } from '../model/planning/PlanningUnassignedGridRow'
import { RunsheetUnassignedGridRow } from '../model/runsheet/RunsheetUnassignedGridRow'

export const getUnassignedRowFromOrder = (order: Order, scheduleId: EntityId): PlanningUnassignedGridRow | RunsheetUnassignedGridRow => {
  const isPickup = order.isPickup
  const customerLocation = isPickup ? order.fromLocation : order.toLocation
  const depotLocation = isPickup ? order.toLocation : order.fromLocation

  // Parse service time
  const serviceTimeStr = isPickup ? order.serviceTimePickup : order.serviceTimeDelivery
  const serviceTime = serviceTimeStr ? parseFloat(serviceTimeStr) : 0

  const row = {
    id: order.id,
    scenarioId: scheduleId,
    runsheetId: scheduleId,

    // Grid Table Row Props
    isDraggable: true,
    isDroppable: false,
    isSelectable: true,
    hasHotAction: true,
    hasActions: true,
    textHighlight: false,
    dragType: GridTableDragType.UNASSIGNED_ORDER_ROW,
    acceptDropTypes: [GridTableDragType.SHIFT_STOP_ROW, GridTableDragType.UNASSIGNED_ORDER_ROW, GridTableDragType.INBOX_ORDER_ROW],

    // Order Details Row
    orderId: order.id,
    orderNumber: order.orderNumber,
    preferredDateOfOperation: order.preferredDateOfOperation,
    orderType: isPickup ? 'Pickup' : 'Delivery',
    weight: order.weight,
    volume: order.volume,
    orderQuantity: order.quantity,
    timeWindows: order.timeWindows,
    serviceTime: serviceTime,
    priority: order.priority,
    maxOnboardTime: order.maxOnboardTime,
    tripNumber: order.tripNumber,
    consignmentNumber: order.consignmentNumber || '',
    description: order.description,
    deliveryInstruction: order.deliveryInstruction || '',
    driverNote: order?.driverNote || '',
    comment: order.comment || '',
    statusType: OrderStatusTypeString[order?.statusType], // Runsheet Only
    statusCellStyle: {
      backgroundColor: order?.bgColor, // Runsheet Only
      color: order?.fgColor, // Runsheet Only
    },

    // Customer Address Details Row
    isGeocoded: customerLocation.isGeocoded,
    geocodeError: customerLocation?.isGeocoded ? undefined : {
      tooltipText: 'Order not geocoded',
      type: 'warning' as AlertType,
      icon: faEarth,
    },
    customerAddress: customerLocation.displayAddress,
    customerSuburb: customerLocation.suburb,
    customerState: customerLocation.state,
    customerPostcode: customerLocation.postcode,
    customerMapRef: customerLocation.mapRef || '',
    customerAdditional: customerLocation.additional || '',
    customerLongitude: customerLocation.x,
    customerLatitude: customerLocation.y,

    customerNumber: customerLocation.externalId || '',
    customerName: customerLocation.name || '',

    // Depot Details Row
    depotCode: depotLocation.externalId || '',
    depotName: depotLocation.name || '',
    depotDisplayAddress: depotLocation.displayAddress || '',
  }

  return row
}